import { render, staticRenderFns } from "./header.vue?vue&type=template&id=467f20d2&scoped=true&"
import script from "./header.vue?vue&type=script&lang=js&"
export * from "./header.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=467f20d2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467f20d2",
  null
  
)

export default component.exports